import { ApiProperty } from "@nestjs/swagger";

export class fgStockTransferReq{
    @ApiProperty()
    transferType : string;

    @ApiProperty()
    Date :Date;

    @ApiProperty()
    unitId: number;

}

export class fgStockRepackingReportReq{
    transferType?: string;
    fromOutDate?:string
    fromInDate?:string
    toOutDate?:string
    toInDate?:string
}